import { motion } from "framer-motion";
import SceneShell from "../components/SceneShell";
import CastleGraphic from "../components/CastleGraphic";

/**
 * Scene 49 — "Why Social Week?" opener.
 * Empty stage with faint hill silhouette · sets up the metaphor.
 */

export default function Scene49_WhyCastle() {
  return (
    <SceneShell variant="ink" align="center" data-testid="scene-why-castle">
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at 50% 60%, rgba(212,148,10,0.10) 0%, transparent 60%)",
            "radial-gradient(ellipse at 50% 60%, rgba(233,168,32,0.18) 0%, transparent 60%)",
            "radial-gradient(ellipse at 50% 60%, rgba(212,148,10,0.10) 0%, transparent 60%)",
          ],
        }}
        transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="relative w-full h-full flex items-center justify-center">
        <motion.h2
          initial={{ opacity: 0, y: 24, filter: "blur(8px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{ duration: 1.2, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="kn-display text-4xl sm:text-6xl lg:text-7xl text-white text-center leading-[1.1] max-w-[1300px] mx-auto pb-2 relative z-10"
          data-testid="why-castle-headline"
        >
          Why{" "}
          <span
            style={{
              background:
                "linear-gradient(135deg, #d4940a 0%, #e9a820 50%, #d4940a 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
              fontWeight: 900,
            }}
          >
            Social Week
          </span>{" "}
          protects us from
          <br />
          the{" "}
          <span style={{ color: "#e9a820", fontWeight: 800 }}>
            AI revolution.
          </span>
        </motion.h2>

        {/* Empty hills with faint atmosphere — softly underlay */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.32 }}
          transition={{ duration: 2.0, delay: 1.4 }}
          className="absolute inset-0 flex items-end justify-center pointer-events-none"
        >
          <div className="w-full max-w-[1400px]">
            <CastleGraphic layer={0} />
          </div>
        </motion.div>
      </div>
    </SceneShell>
  );
}
